import React from "react";
import { bool, func, shape, string } from "prop-types";
import { connect } from "react-redux";
import { compose } from "redux";
import { Redirect, withRouter } from "react-router-dom";
import { Box, MetrocorpOperations } from "@ui-kit/components/index.es";

import { resizableRoute } from "pages/_components/Resizable";
import MetrocorpExtractsConnected from "pages/metrocorp/_components/MetrocorpExtractsConnected";
import { selectors as metrocorpSelectors } from "reducers/metrocorp";
import { selectors as settingsSelectors } from "reducers/settings";
import { selectors as statusSelectors } from "reducers/status";
import { METROCORP_SOAP_PATH } from "util/metrocorpRoutes";
import { useMetrocorpOperationsPage } from "./useMetrocorpOperationsPage";

function MetrocorpOperationsV3Page({
    dispatch,
    fetchingDownload,
    fetchingPerformance,
    hideAmount,
    isDesktop,
    lastHrefPathname,
    location,
}) {
    const {
        metrocorpV3Enabled,
        showSpinner,
        goBack,
        getLabels,
        section,
        setSection,
        futureValuesCount,
        holdingsSection,
        futureValuesSection,
        metrocorpMovementsEnabled,
        movementsSection,
        extractsEnabled,
        onOpenExtracts,
        extractsDisabled,
        extractAccountsOptions,
        defaultExtractAccount,
        extractDefaultMonth,
        extractMinDate,
        getExtractTexts,
        onSubmitExtracts,
        onSetExtractsOpen,
        onDownloadList,
        isListLoading,
    } = useMetrocorpOperationsPage({
        dispatch,
        fetchingDownload,
        fetchingPerformance,
        hideAmount,
        isDesktop,
        lastHrefPathname,
        location,
    });

    if (!metrocorpV3Enabled) {
        return <Redirect to={METROCORP_SOAP_PATH} />;
    }

    return (
        <Box mb={16}>
            <MetrocorpOperations
                goBack={goBack}
                getLabels={getLabels}
                section={section}
                onSectionChange={setSection}
                enableFutureValues
                enableMovements={metrocorpMovementsEnabled}
                futureValuesCount={futureValuesCount}
                holdingsSection={holdingsSection}
                futureValuesSection={futureValuesSection}
                movementsSection={movementsSection}
                loading={showSpinner}
                onOpenExtracts={onOpenExtracts}
                extractsDisabled={extractsDisabled}
                onDownloadList={onDownloadList}
                isListLoading={isListLoading}
                extractsSlot={
                    extractsEnabled ? (
                        <MetrocorpExtractsConnected
                            hideTrigger
                            accountsOptions={extractAccountsOptions}
                            getTexts={getExtractTexts}
                            defaultAccount={defaultExtractAccount}
                            defaultMonth={extractDefaultMonth}
                            minDate={extractMinDate}
                            onSubmit={onSubmitExtracts}
                            setOpen={onSetExtractsOpen}
                        />
                    ) : null
                }
            />
        </Box>
    );
}

MetrocorpOperationsV3Page.propTypes = {
    dispatch: func.isRequired,
    fetchingDownload: bool.isRequired,
    fetchingPerformance: bool.isRequired,
    hideAmount: bool.isRequired,
    isDesktop: bool.isRequired,
    lastHrefPathname: string,
    location: shape({
        pathname: string,
        state: shape({
            return: string,
            metrocorpHoldingsFilters: shape({
                accountId: string,
                verifyCode: string,
                speciesId: string,
            }),
        }),
    }),
};

MetrocorpOperationsV3Page.defaultProps = {
    lastHrefPathname: "",
    location: {},
};

const mapStateToProps = (state) => ({
    fetchingDownload: Boolean(metrocorpSelectors.getFetchingDownload(state)),
    fetchingPerformance: metrocorpSelectors.getFetchingPerformance(state),
    hideAmount: Boolean(settingsSelectors.getUserData(state)?.hideBalance),
    lastHrefPathname: statusSelectors.getPathname(state) || "",
});

export default compose(connect(mapStateToProps), withRouter, resizableRoute)(MetrocorpOperationsV3Page);
